<template>
  <page>
    <div class="shadow-25">
      <v-header :title="$metaInfo.title" icon="public" />
      <card width="100%">
        <p>Tabela de marcados</p>
      </card>
    </div>
  </page>
</template>

<script>
import axios from "axios";
import { QTable, QTr, QTd } from "quasar-framework";
export default {
  middleware: "auth",
  metaInfo() {
    return { title: this.$T("new market") };
  },
  components: {
    QTable,
    QTr,
    QTd
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/market/management.vue